import { TreeTableDesignTokens } from '@primeuix/themes/aura/treetable';

export const treeTableTokens: TreeTableDesignTokens = {
  root: {
    transitionDuration: '{transition.duration}',
  },
  header: {
    background: '{content.background}',
    borderColor: '{treetable.border.color}',
    borderWidth: '1px',
    color: '{content.color}',
    padding: '0.75rem 1rem',
  },
  headerCell: {
    background: '{content.background}',
    hoverBackground: '{content.hover.background}',
    hoverColor: '{content.hover.color}',
    selectedBackground: '{highlight.background}',
    selectedColor: '{highlight.color}',
    borderColor: '{treetable.border.color}',
    color: '{content.color}',
    gap: '0.5rem',
    padding: '0.75rem 1rem',
    focusRing: {
      width: '{focus.ring.width}',
      offset: '-1px',
      style: '{focus.ring.style}',
      color: '{focus.ring.color}',
      shadow: '{focus.ring.shadow}',
    },
  },
  columnTitle: {
    fontWeight: '600',
  },
  row: {
    background: '{content.background}',
    hoverBackground: '{content.hover.background}',
    hoverColor: '{content.hover.color}',
    selectedBackground: '{highlight.background}',
    selectedColor: '{highlight.color}',
    color: '{content.color}',
    focusRing: {
      width: '{focus.ring.width}',
      offset: '-1px',
      style: '{focus.ring.style}',
      color: '{focus.ring.color}',
      shadow: '{focus.ring.shadow}',
    },
  },
  bodyCell: {
    borderColor: '{treetable.border.color}',
    padding: '0.75rem 1rem',
  },
  footerCell: {
    background: '{content.background}',
    borderColor: '{treetable.border.color}',
    color: '{content.color}',
    padding: '0.75rem 1rem',
  },
  columnFooter: {
    fontWeight: '600',
  },
  footer: {
    background: '{content.background}',
    borderColor: '{treetable.border.color}',
    borderWidth: '1px',
    color: '{content.color}',
    padding: '0.75rem 1rem',
  },
  columnResizer: {
    width: '0.5rem',
  },
  resizeIndicator: {
    width: '1px',
    color: '{primary.color}',
  },
  sortIcon: {
    color: '{text.muted.color}',
    hoverColor: '{text.hover.muted.color}',
    size: '0.875rem',
  },
  loadingIcon: {
    size: '2rem',
  },
  nodeToggleButton: {
    hoverBackground: '{content.hover.background}',
    hoverColor: '{text.color}',
    selectedHoverBackground: '{content.background}',
    selectedHoverColor: '{primary.color}',
    color: '{text.muted.color}',
    size: '1.75rem',
    borderRadius: '{treetable.node.toggle.button.size} / 2',
    focusRing: {
      width: '{focus.ring.width}',
      style: '{focus.ring.style}',
      offset: '{focus.ring.offset}',
      color: '{focus.ring.color}',
      shadow: '{focus.ring.shadow}',
    },
  },
  paginatorTop: {
    borderColor: '{treetable.border.color}',
    borderWidth: '1px',
  },
  paginatorBottom: {
    borderColor: '{treetable.border.color}',
    borderWidth: '1px',
  },
  colorScheme: {
    light: {
      root: {
        borderColor: '{content.border.color}',
      },
      bodyCell: {
        selectedBorderColor: '{primary.100}',
      },
    },
    dark: {
      root: {
        borderColor: '{surface.500}',
      },
      bodyCell: {
        selectedBorderColor: '{primary.900}',
      },
    },
  },
};
